/* eslint-disable no-return-assign */
import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';
import Alert from 'react-s-alert';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import moment from 'moment';
import useFormValidator from 'useFormValidator';
import CmsContext from 'context/CmsContext';
import * as actions from '../action';
import * as c from '../constant';

const validationForm = {
  serial_number: 'required|cedula_serial_number',
  date_issued: 'required|date'
}

function RegenerateCorporationCedula({ data, showTransaction, id }) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_MASKINGS = cmsContext.findByType('MASKINGS');

  const [formData, setFormData] = useState({
    date_issued: moment().format('MM/DD/YYYY'),
    serial_number: '',
    isLoading: false,
    regenerate: false,
    url: '',
  });

  const formValidator = useFormValidator(formData, validationForm)

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
    showTransaction(id);
  };

  const token = get('token') || '';

  const authProfile = getJson('profile') || {};

  const handleOnChangeDate = key => e => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  const onChangeText = e => {
    // remove underscore: quick fix
    const currentOnChangeValue = e.target.value.includes('_')
      ? e.target.value.replace(/_/g, '')
      : e.target.value;

    setFormData({
      ...formData,
      [e.target.name]: currentOnChangeValue,
    });
  };

  const handleRegenerate = e => {
    e.preventDefault();

    setFormData({
      ...formData,
      isLoading: true,
      generate: true,
      url: '',
    });

    const src = `${process.env.REACT_APP_WS}${c.REGENERATE_CEDULA_URI.replace(
      '{id}',
      _.get(data, 'id')
    )}?bearer_token=${token}&date_issued=${moment(
      _.get(formData, 'date_issued')
    ).format('YYYY-MM-DD')}&serial_number=${_.get(
      formData,
      'serial_number'
    )}&email=${_.get(authProfile, 'email')}`;

    setFormData({
      ...formData,
      isLoading: false,
      regenerate: false,
    });

    let iframe = document.getElementById("ex-download-iframe");
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.id = 'ex-download-iframe';
      iframe.style.display = 'none'
      document.body.appendChild(iframe);
      Alert.error("Serial Number already used in other transaction. Please try again.");
    } else {
      iframe.src = src;
      setModal({ isOpen: false });
      showTransaction(id);
    }
  };

  useEffect(() => {
    if(!_.get(CMS_MASKINGS, "DEFAULT_CEDULA_SERIAL_NUMBER")) {
      formValidator.onSetObjectRules({
        ...validationForm,
        serial_number: `required|mask:${_.get(CMS_MASKINGS, "CEDULA_SERIAL_NUMBER_REGEX")}~${_.get(CMS_MASKINGS, "CEDULA_SERIAL_NUMBER")}`,
      })
    }
    
  }, [_.get(CMS_MASKINGS, "DEFAULT_CEDULA_SERIAL_NUMBER")])

  return (
    <Modal.Body>
      <form onSubmit={handleRegenerate}>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <div className="form-input-group">
                  <label className="form-control-plaintext">
                    Serial Number&nbsp;
                    {formValidator.renderMessage('serial_number')}
                  </label>
                  <div className="input-group  mb-3">
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        {_.get(CMS_MASKINGS, "CEDULA_CORPORATE_SERIAL_NO_LABEL") ? _.get(CMS_MASKINGS, "CEDULA_CORPORATE_SERIAL_NO_LABEL") : `CCC ${new Date().getFullYear()}`}
                      </span>
                    </div>
                    <InputMask
                      required
                      mask={_.get(CMS_MASKINGS, "DEFAULT_CEDULA_SERIAL_NUMBER") ? "99999999" : _.get(CMS_MASKINGS, "CEDULA_SERIAL_NUMBER")}
                      maskChar=""
                      className="form-control"
                      value={_.get(formData, 'serial_number')}
                      name="serial_number"
                      onChange={onChangeText}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-input-group ">
                  <label className="form-control-plaintext">
                    Date Issued&nbsp;
                    {formValidator.renderMessage('date_issued')}
                  </label>
                  <DateInputPicker
                    required
                    className="full-input"
                    onChange={handleOnChangeDate('date_issued')}
                    value={_.get(formData, 'date_issued')}
                    maxDate={new Date()}
                  />
                </div>
              </div>
              <div className="col">
                <div className="form-input-group">
                  <label className="form-control-plaintext">&nbsp;</label>
                </div>
              </div>
            </div>
            <hr />
            {_.get(formData, 'isLoading') && (
              <div className="loading">
                <div className="spinner text-center">
                  <span className="fas fa-1x fa-spin fa-spinner fa-lg" />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={
              _.get(formData, 'isLoading') || !formValidator.response.is_passed
            }
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary "
          >
            {_.get(formData, 'isLoading') ? (
              <i className="fa fa-spin fa-spinner" />
            ) : (
              `Regenerate`
            )}
          </button>
          &nbsp;
          <button
            disabled={_.get(formData, 'isLoading')}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

RegenerateCorporationCedula.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(RegenerateCorporationCedula);
